/**
 * Created by asiulik on 29.11.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', './filterConfig', './filter'], function($, _, EventEmitter, FilterConfig, Filter){

    function Filters(){}

    Filters.prototype = _.clone(EventEmitter.prototype);

    Filters.prototype.init = function(){

        var _this = this;

        this.$filters = $(FilterConfig.filtersSelector);

        this.filters = [];

        if(!this.$filters.length) return;

        [].forEach.call(this.$filters, function(filterElement){

            var $filterElement = $(filterElement);

            var filterInstance = new Filter($filterElement);
            filterInstance.init();

            _this.filters.push(filterInstance);

        })

        this.bindEvents();

    };

    Filters.prototype.bindEvents = function(){

        var _this = this;

        this.filters.map(function(filterInstance) {

            filterInstance.on('filter:content:contentChanged', function(contentCollection){

                _this.emit('filter:content:contentChanged', contentCollection);

            });

        });

    };

    return Filters;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/filters/filters.js